import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Layout/Navbar"; 
import Home from "./pages/Home";
import Services from "./components/Services";          
import Team from "./components/Team";
import Footer from "./Layout/Footer";
import Sublime from "./components/Sublime";
import Consult from "./components/Consult";
import Booking from "./Components-2/Booking";   // ✅ Import Booking page

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div id="home">
                <Home />
              </div>
              <div id="services">
                <Services />
              </div>
              <div id="team">
                <Team />
              </div>
              <div id="sublime">
                <Sublime />
              </div>
              <div id="consult">
                <Consult />
              </div>
            </>
          }
        />
        <Route path="/booking" element={<Booking />} />
      </Routes>

      {/* ✅ Footer always visible */}
      <div id="footer">
      <Footer />
      </div>
    </Router>
  );
}

export default App;
